<template>
  <v-container>
    <h1>Set Wiki Where Null</h1>

    <progress-component script="SetWikiWhereNull"></progress-component>
  </v-container>
</template>

<script>
import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'SetWikiWhereNull',
  components: { ProgressComponent },
};
</script>
